export const environment = {
  production: false,
  logLevel: 5,
  apiUrl: '/api'
};
